export const carpayPaidOrderRoute = `/carpay/paid-order`
